import React from "react";
import PropTypes from "prop-types";

function SegmentedProgress(props) {
	var segmentID = 1;
	return (
		<div className="progressBar">
			<div className="segmentContainer">
				{props.segmentTitles.map(title => 
					<Segment 
						title={title} 
						isCurrent={segmentID === props.currentSegment} 
						key={segmentID++} 
					/>
				)}
			</div>
		</div>
	);
}

SegmentedProgress.propTypes = {
	segmentTitles: PropTypes.array,
	currentSegment: PropTypes.number
};

function Segment(props) {
	let spanID = props.isCurrent ? "currentStep" : "";
	return (
		<div className="segment" id={spanID}>
			<span className="segmentContainer__inner">
				<span className="segmentContainer__title">{props.title}</span>
			</span>
		</div>
	);
}

Segment.propTypes = {
	title: PropTypes.string,
	isCurrent: PropTypes.bool
};

export default SegmentedProgress;


// WEBPACK FOOTER //
// ./src/components/SegmentedProgress.js